@if (state.status === 'loading' && !hasData) {
  <div class="async-state-skeleton" role="status" aria-live="polite" aria-busy="true">
    <span class="async-state-skeleton__line async-state-skeleton__line--wide"></span>
    <span class="async-state-skeleton__line"></span>
    <span class="async-state-skeleton__line async-state-skeleton__line--short"></span>
    <span class="visually-hidden">{{ loadingLabel }}</span>
  </div>
}

@if (showsRefreshFeedback) {
  <div class="async-state-refresh" role="status" aria-live="polite" aria-busy="true">
    <mat-progress-spinner color="primary" mode="indeterminate" diameter="18" aria-label="Cargando"></mat-progress-spinner>
    <span>{{ refreshingLabel }}</span>
  </div>
}

@if (showsBlockingError) {
  <div class="async-state-error" role="alert">
    <mat-icon aria-hidden="true">error_outline</mat-icon>
    <span>{{ errorLabel }}</span>
    <button mat-stroked-button type="button" (click)="requestRetry()">{{ retryLabel }}</button>
  </div>
}

@if (state.status === 'success' && empty) {
  <div class="async-state-empty" role="status" aria-live="polite">
    <mat-icon aria-hidden="true">inbox</mat-icon>
    <span>{{ emptyLabel }}</span>
  </div>
}

@if (showsInlineError) {
  <div class="async-state-inline-error" role="alert">
    <mat-icon aria-hidden="true">error_outline</mat-icon>
    <span>{{ errorLabel }}</span>
    <button mat-button type="button" (click)="requestRetry()">{{ retryLabel }}</button>
  </div>
}

<ng-content></ng-content>
